import React, { Component, Fragment } from "react";

import { default as CustomerDetailsCard } from "./components/CustomerDetailsCard.js";
import { default as CustomerAccountManagersCard } from "./components/CustomerAccountManagersCard.js";
import { default as CustomerProjectsCard } from "./components/CustomerProjectsCard.js";
import { default as CustomerUserActions } from "./components/CustomerUserActions.jsx";

import {
  AddProjectModal,
  EditCustomerIndustriesModal,
  EditCustomerBusinessNameModal,
  EditCustomerBusinessClientNotesModal,
  EditCustomerAccountManagersModal,
} from "./components/modals";

class CustomerViewPage extends Component {
  componentDidMount() {
    this.props.fetchCustomer(this.props.match.params.id);
  }

  render() {
    let { isLoading } = this.props;
    return (
      <Fragment>
        {isLoading ? (
          <Fragment />
        ) : (
          <div className="row">
            <div className="col-sm-12 col-md-4 p-1">
              <CustomerDetailsCard />
              <CustomerAccountManagersCard />
            </div>
            <div className="col-sm-12 col-md-8 p-1">
              <CustomerProjectsCard />
              <CustomerUserActions customerId={this.props.match.params.id} />
            </div>
            <EditCustomerIndustriesModal />
            <EditCustomerBusinessNameModal />
            <EditCustomerBusinessClientNotesModal />
            <EditCustomerAccountManagersModal />
            <AddProjectModal />
          </div>
        )}
      </Fragment>
    );
  }
}

export default CustomerViewPage;
